<div id="loader-block" class="spinnerloader" *ngIf="show">
  <div class="spinnerText">
    <i name="spinner" class="fa fa-spinner fa-spin spinner-icon" aria-hidden="true" animation="pulse"></i>
  </div>